export default __webpack_public_path__ + "static/media/docs-icon.3c4a5362.svg";